import { ChakraProvider } from "@chakra-ui/react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { SomethingWentWrongDialog } from "./components/SomethingWentWrongDialog/SomethingWentWrongDialog";
import store from "./reducers/configureStore";
import { Router } from "./Router";
import theme from "./styles/theme";

function App() {
  return (
    <Provider store={store}>
      <ChakraProvider theme={theme}>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
        <SomethingWentWrongDialog />
      </ChakraProvider>
    </Provider>
  );
}

export default App;
